import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Blog.css';

const Blog = () => {
    const [blogPosts, setBlogPosts] = useState([]);

    useEffect(() => {
        // Fetches blog posts from the backend
        axios.get(process.env.REACT_APP_API_URL || 'https://back-of-the-portfolio-ef1ea5ab6707.herokuapp.com/blogs')
            .then((response) => {
                const sortedPosts = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                setBlogPosts(sortedPosts);
            })
            .catch((error) => {
                console.error('Error fetching blog posts:', error);
            });
    }, []);

    return (
        <div className="blog-container">
            <div className="title-wrapper">
                <h1 className="blog-page-title">A Blog</h1>
            </div>
            <div className="blog-posts">
                {blogPosts.map((post) => (
                    <div key={post.id} className="blog-post">
                        <img src={post.image_url} alt={post.title} className="blog-image" />
                        <p className="blog-post-date">
                            {new Date(post.created_at).toLocaleDateString()}
                        </p>
                        <h2>{post.title}</h2>
                        <p className="blog-synopsis"> {post.synopsis} 
                        </p>
                        <a
                            href={post.blog_content}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="read-more-button"
                        >
                            Read More
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Blog;
